import React from 'react';

interface CopyButtonProps {
  copied: boolean;
  onClick: () => void;
  colorClass?: string;
}

/**
 * Reusable copy button component with SVG icons
 * Shows a checkmark when copied, clipboard icon otherwise
 */
export const CopyButton: React.FC<CopyButtonProps> = ({ 
  copied, 
  onClick, 
  colorClass = "text-white hover:text-blue-300" 
}) => (
  <button
    onClick={onClick}
    className={`bg-transparent border-0 p-0 cursor-pointer ${colorClass} transition-colors flex-shrink-0`}
    title={copied ? "Copied!" : "Copy prompt"}
  >
    {copied ? (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    ) : (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
      </svg>
    )}
  </button>
);
